<div class="pod-data-container">
    <form fxLayout="column" [formGroup]="form">
        <ng-container *ngIf="isConsumer && !isPlant">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="mb-10">
                <app-icon name="fal-plug"></app-icon>
                <span class="txt-h-20-7">{{'Absorption energy data of {0}'|i18n:resource.name}}</span>
            </div>
            <div class="txt-p-18-4 mb-20">{{'Mode {0}'|i18n:((this.rateMode|rateMode)|i18n)}}</div>
            <div class="txt-s-18-4 mb-10">{{'Enter total absorption data for each month.'|i18n}}</div>
            <div class="txt-s-18-4 mb-10" *ngIf="this.rateMode === RateMode.HOURLY">
                {{'For each month, differentiate the absorption data for each time slot.'|i18n}}
            </div>
        </ng-container>
        <ng-container *ngIf="isProducer">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="mb-10">
                <app-icon name="fal-solar-panel"></app-icon>
                <span class="txt-h-20-7">{{'Injection energy data of {0}'|i18n:resource.name}}</span>
            </div>
            <div class="txt-p-18-4 mb-20">{{'Mode {0}'|i18n:((this.rateMode|rateMode)|i18n)}}</div>
            <div class="txt-s-18-4 mb-10">{{'Enter total injection data for each month.'|i18n}}</div>
            <div class="txt-s-18-4 mb-10" *ngIf="this.rateMode === RateMode.HOURLY">
                {{'For each month, differentiate the injection data for each time slot.'|i18n}}
            </div>
        </ng-container>
        <ng-container *ngIf="isPlant">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="mb-10">
                <app-icon name="fal-solar-panel"></app-icon>
                <span class="txt-h-20-7">{{'Production energy data of {0}'|i18n:resource.name}}</span>
            </div>
            <div class="txt-p-18-4 mb-20">{{'Mode {0}'|i18n:((this.rateMode|rateMode)|i18n)}}</div>
            <div class="txt-s-18-4 mb-10">{{'Enter total production data for each month.'|i18n}}</div>
            <div class="txt-s-18-4 mb-10" *ngIf="this.rateMode === RateMode.HOURLY">
                {{'For each month, differentiate the production data for each time slot.'|i18n}}
            </div>
        </ng-container>
        <ng-container *ngIf="isProsumer">
            <div class="txt-h-20-7 mb-10">{{'Absorption and injection energy data of {0}'|i18n:resource.name}}</div>
            <div class="txt-p-18-4 mb-20">{{'Mode {0}'|i18n:((this.rateMode|rateMode)|i18n)}}</div>
            <div class="txt-s-18-4 mb-10">{{'Enter total absorption and injection data for each month.'|i18n}}</div>
            <div class="txt-s-18-4 mb-10" *ngIf="this.rateMode === RateMode.HOURLY">
                {{'For each month, differentiate the absorption and injection data for each time slot.'|i18n}}
            </div>
        </ng-container>
        <div class="txt-s-18-4 mb-36">
            {{((isConsumer && !isPlant) || isProsumer ?
            'As an alternative you can choose a predefined template and enter an yearly consumption total.' :
            'As an alternative you can choose a predefined template and enter an yearly production total.')|i18n}}
        </div>
        <div fxLayout="column" fxLayoutGap="30px" class="mb-20 panel">
            <div class="txt-h-18-7">{{'Compilation with template'|i18n}}</div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <div class="txt-p-16-4">
                    {{((isConsumer && !isPlant) || isProsumer ? 'Consumption profile' : 'Production profile')|i18n}}:
                </div>
                <mat-select app-small-select formControlName="template" fxFlex="60"
                            placeholder="{{'Choose a profilation template'|i18n}}"
                            (selectionChange)="onTemplateSelectionChange($event)"
                            [disabled]="filteredTemplates.length === 0">
                    <mat-option *ngFor="let template of filteredTemplates" [value]="template">
                        <em>{{template.name|i18n}}</em>
                    </mat-option>
                </mat-select>
            </div>
            <div *ngIf="(isConsumer && !isPlant ) || isProsumer" app-input-container fxLayout="row"
                 fxLayoutAlign="start center"
                 fxLayoutGap="20px" class="txt-p-16-4">
                <div>{{'Yearly consumption total'|i18n}}:</div>
                <input app-input
                       type="number"
                       step="0.01"
                       formControlName="yearlyConsumption"
                       (input)="limitDecimals(form, 'yearlyConsumption')"
                       fxFlex="20">
                <span>kWh</span>
                <app-icon icon-color-h name="fas-info-circle"
                          [title]="(isProsumer ?
                          'By entering a total consumption, monthly absorption and injection data are calculated according to seasonal statistics and taking into account self-consumption from connected production plants.':
                          'By entering a total, months consumptions will be automatically calculated from seasonal statistics.')|i18n">
                </app-icon>
            </div>
            <div *ngIf="isWindPlant" app-input-container fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="txt-p-16-4">
                <div>{{'Yearly equivalent hours'|i18n}}:</div>
                <input app-input
                       type="number"
                       step="0.01"
                       formControlName="yearlyHours"
                       (input)="limitDecimals(form, 'yearlyHours')"
                       fxFlex="20">
                <span>{{'hours'|i18n}}</span>
            </div>
            <div *ngIf="showWarning" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px" economics-warning>
                <app-icon icon-color-w name="fas-info-circle"></app-icon>
                <span>{{warningText}}</span>
            </div>
            <div *ngIf="isProsumer" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px" generic-info>
                <app-icon icon-color-h name="fas-info-circle"></app-icon>
                <span>{{'Entering the yearly consumption, the platform will calculate absorption and injection for each month thanks to the statistical profiles of the production plants.'|i18n}}</span>
            </div>
        </div>
        <div class="panel">
            <div class="txt-h-18-7">{{'Monthly values'|i18n}}</div>
            <div [style.visibility]="showSpinner ? 'visible' : 'hidden'" fxLayout="row" fxLayoutAlign="center center">
                <mat-spinner app-spinner diameter="20"></mat-spinner>
                <span class="pl-8">{{'Loading'|i18n}}...</span>
            </div>
            <ng-container *ngIf="isConsumer || isProducer || isPlant">
                <ng-container *ngIf="rateMode === RateMode.SINGLE">
                    <div fxLayout="row" class="mt-20 mb-36">
                        <div fxLayout="column" fxLayoutGap="30px"
                             *ngFor="let semester of [FIRST_SEMESTER, SECOND_SEMESTER]">
                            <ng-container *ngFor="let month of semester">
                                <div fxLayout="row" fxLayoutAlign="center center">
                                    <div fxFlex="25" class="txt-p-16-7">{{month|i18n}}</div>
                                    <div fxFlex="1"></div>
                                    <div app-input-container fxLayout="row" fxLayoutAlign="start center"
                                         fxLayoutGap="10px"
                                         fxFlex="50" class="txt-p-16-4">
                                        <input app-input
                                               type="number"
                                               step="0.01"
                                               [formControlName]="month"
                                               (input)="limitDecimals(form, month)">
                                        <span>kWh</span>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="rateMode === RateMode.HOURLY">
                    <ng-container *ngFor="let month of MONTHS">
                        <div fxLayout="column" fxLayoutGap="20px" class="mt-52 mb-36">
                            <div>
                                <span fxFlex="8"></span>
                                <span class="txt-p-16-7">{{month|i18n}}</span>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <span fxFlex="8"></span>
                                <div *ngFor="let slot of SLOTS" fxFlex>
                                    <div app-input-container fxLayout="row" fxLayoutAlign="start center"
                                         fxLayoutGap="10px" class="txt-p-16-4" fxFlex="80">
                                        <span>{{slot}}</span>
                                        <input app-input
                                               type="number"
                                               step="0.01"
                                               [formControlName]="month+'_'+slot"
                                               (input)="limitDecimals(form, month+'_'+slot)">
                                    </div>
                                    <span fxFlex="5"></span>
                                </div>
                                <span class="txt-p-16-4">kWh</span>
                                <span fxFlex="8"></span>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="isProsumer">
                <div fxLayoutAlign="center">
                    <div fxLayout="column" fxLayoutGap="10px" class="txt-s-14-4 mb-30">
                        <span>{{'LEGEND'|i18n}}</span>
                        <div fxLayout="row" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutGap="20px">
                                <app-icon name="fal-plug"></app-icon>
                                <span>{{'Absorption'|i18n}}</span>
                            </div>
                            <div fxLayout="row" fxLayoutGap="20px">
                                <app-icon name="fal-solar-panel"></app-icon>
                                <span>{{'Injection'|i18n}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="rateMode === RateMode.SINGLE">
                    <div fxLayout="row" fxLayoutGap="150px" class="mb-36">
                        <div fxLayout="column" fxLayoutGap="30px"
                             *ngFor="let semester of [FIRST_SEMESTER, SECOND_SEMESTER]">
                            <ng-container *ngFor="let month of semester">
                                <div fxLayout="column" fxLayoutGap="20px" class="mt-20">
                                    <div fxLayoutAlign="start center" fxFlex="20"
                                         class="txt-p-16-7 ml-30">{{month|i18n}}</div>
                                    <div fxLayout="row" fxLayoutAlign="center center" *ngFor="let type of ENERGY_TYPES">
                                        <div app-input-container fxLayout="row" fxLayoutAlign="start center"
                                             fxLayoutGap="10px"
                                             fxFlex="65">
                                            <app-icon class="txt-s-16-4 energy-type-icon" fxLayoutAlign="center"
                                                      [name]="type === EnergyType.ABSORBED ? 'fal-plug' : 'fal-solar-panel'"></app-icon>
                                            <input app-input
                                                   type="number"
                                                   step="0.01"
                                                   [formControlName]="month+'_'+type"
                                                   (input)="limitDecimals(form, month+'_'+type)"
                                                   class="txt-p-16-4">
                                            <span class="txt-p-16-4">kWh</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="rateMode === RateMode.HOURLY">
                    <ng-container *ngFor="let month of MONTHS">
                        <div fxLayout="column" fxLayoutGap="20px" class="mb-36">
                            <div>
                                <span fxFlex="8"></span>
                                <span class="txt-p-16-7">{{month|i18n}}</span>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
                                <div fxLayout="row" fxLayoutAlign="start center" *ngFor="let type of ENERGY_TYPES">
                                    <span fxFlex="8"></span>
                                    <div fxLayout="row" fxLayoutAlign="center" fxFlex="5">
                                        <app-icon class="txt-s-16-4 energy-type-icon" fxLayoutAlign="center"
                                                  [name]="type === EnergyType.ABSORBED ? 'fal-plug' : 'fal-solar-panel'">
                                        </app-icon>
                                    </div>
                                    <span fxFlex="5"></span>
                                    <div *ngFor="let slot of SLOTS" fxFlex>
                                        <div app-input-container fxLayout="row" fxLayoutAlign="start center"
                                             fxLayoutGap="10px" fxFlex="80">
                                            <span class="txt-p-16-4">{{slot}}</span>
                                            <input app-input
                                                   type="number"
                                                   step="0.01"
                                                   [formControlName]="month+'_'+type+'_'+slot"
                                                   (input)="limitDecimals(form, month+'_'+type+'_'+slot)"
                                                   class="txt-p-16-4">
                                        </div>
                                        <span fxFlex="5"></span>
                                    </div>
                                    <span class="txt-p-16-4">kWh</span>
                                    <span fxFlex="8"></span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>

        <!-- Totals -->
        <ng-container *ngIf="isConsumer || isProducer">
            <ng-container *ngIf="rateMode === RateMode.SINGLE">
                <div *ngIf="isDefined(totals)"
                     fxLayout="column" fxLayoutGap="30px" class="mt-40 mb-40">
                    <div fxLayoutAlign="center" class="txt-p-16-7">{{'Energy data preview of the year'|i18n}}:</div>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="txt-p-16-4">
                        <div fxFlex="5" fxLayoutAlign="center">
                            <app-icon [name]="isConsumer && !isPlant ? 'fal-plug' : 'fal-solar-panel'"></app-icon>
                        </div>
                        <div>{{(totals[TimeSlot.ALL]|niceValue:'kWh') + ' ' + ((isProducer ? 'injected' : isPlant ? 'produced' : 'absorbed')|i18n)}}</div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="rateMode === RateMode.HOURLY">
                <div class="mt-52 mb-52" *ngIf="isDefined(totals)">
                    <div fxLayoutAlign="center" class="txt-p-16-7">{{'Energy data preview of the year'|i18n}}:</div>
                    <div fxLayout="row" fxLayoutAlign="center" class="mt-40">
                        <div fxLayout="column" fxLayoutGap="20px" fxFlex="75">
                            <div fxLayout="row" fxLayoutAlign="center">
                                <div fxFlex="35"></div>
                                <div fxFlex="16" fxLayoutAlign="center" class="txt-h-16-7">F1</div>
                                <div fxFlex="5"></div>
                                <div fxFlex="16" fxLayoutAlign="center" class="txt-h-16-7">F2</div>
                                <div fxFlex="5"></div>
                                <div fxFlex="16" fxLayoutAlign="center" class="txt-h-16-7">F3</div>
                                <div fxFlex="7"></div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center">
                                <div fxLayout="row" fxLayoutGap="20px" fxFlex="30" fxLayoutAlign="center center"
                                     class="txt-h-16-7">
                                    <div fxFlex="5" fxLayoutAlign="center">
                                        <app-icon [name]="isConsumer && !isPlant ? 'fal-plug' : 'fal-solar-panel'"></app-icon>
                                    </div>
                                    <div>{{(isProducer ? 'Injection' : isPlant ? 'Production' : 'Absorption')|i18n}}</div>
                                </div>
                                <div fxFlex="5"></div>
                                <div fxFlex="16" fxLayoutAlign="center"
                                     class="txt-p-16-4">{{totals[TimeSlot.F1]|niceValue:'kWh'}}</div>
                                <div fxFlex="5"></div>
                                <div fxFlex="16" fxLayoutAlign="center"
                                     class="txt-p-16-4">{{totals[TimeSlot.F2]|niceValue:'kWh'}}</div>
                                <div fxFlex="5"></div>
                                <div fxFlex="16" fxLayoutAlign="center"
                                     class="txt-p-16-4">{{totals[TimeSlot.F3]|niceValue:'kWh'}}</div>
                                <div fxFlex="7"></div>
                            </div>
                        </div>
                        <div class="vert-line"></div>
                        <div fxFlex="2"></div>
                        <div fxLayout="column" fxLayoutGap="20px" fxFlex="15" fxLayoutAlign="center center">
                            <div class="txt-h-16-7">{{'Total'|i18n}}</div>
                            <div class="txt-p-16-7">{{totals[TimeSlot.ALL]|niceValue:'kWh'}}</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="isProsumer">
            <ng-container *ngIf="rateMode === RateMode.SINGLE">
                <div *ngIf="isDefined(totals[MonthlyEnergy.ABSORBED]) && isDefined(totals[MonthlyEnergy.INJECTED])"
                     fxLayout="column" fxLayoutGap="30px" class="mt-40 mb-40">
                    <div fxLayoutAlign="center" class="txt-p-16-7">{{'Energy data preview of the year'|i18n}}:</div>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="txt-p-16-4">
                        <div fxFlex="5" fxLayoutAlign="center">
                            <app-icon name="fal-plug"></app-icon>
                        </div>
                        <div>{{(totals[MonthlyEnergy.ABSORBED][TimeSlot.ALL]|niceValue:'kWh') + ' ' + ('absorbed'|i18n)}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="txt-p-16-4">
                        <div fxFlex="5" fxLayoutAlign="center">
                            <app-icon name="fal-solar-panel"></app-icon>
                        </div>
                        <div>{{(totals[MonthlyEnergy.INJECTED][TimeSlot.ALL]|niceValue:'kWh') + ' ' + ('injected'|i18n)}}</div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="rateMode === RateMode.HOURLY">
                <div class="mt-52 mb-52"
                     *ngIf="isDefined(totals[MonthlyEnergy.ABSORBED]) && isDefined(totals[MonthlyEnergy.INJECTED])">
                    <div fxLayoutAlign="center" class="txt-p-16-7">{{'Energy data preview of the year'|i18n}}:</div>
                    <div fxLayout="row" fxLayoutAlign="center" class="mt-40">
                        <div fxLayout="column" fxLayoutGap="20px" fxFlex="75">
                            <div fxLayout="row" fxLayoutAlign="center">
                                <div fxFlex="35"></div>
                                <div fxFlex="16" fxLayoutAlign="center" class="txt-h-16-7">F1</div>
                                <div fxFlex="5"></div>
                                <div fxFlex="16" fxLayoutAlign="center" class="txt-h-16-7">F2</div>
                                <div fxFlex="5"></div>
                                <div fxFlex="16" fxLayoutAlign="center" class="txt-h-16-7">F3</div>
                                <div fxFlex="7"></div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center">
                                <div fxLayout="row" fxLayoutGap="20px" fxFlex="30" fxLayoutAlign="center center"
                                     class="txt-h-16-7">
                                    <div fxFlex="5" fxLayoutAlign="center">
                                        <app-icon name="fal-plug"></app-icon>
                                    </div>
                                    <div>{{'Absorption'|i18n}}</div>
                                </div>
                                <div fxFlex="5"></div>
                                <div fxFlex="16" fxLayoutAlign="center"
                                     class="txt-p-16-4">{{totals[MonthlyEnergy.ABSORBED][TimeSlot.F1]|niceValue:'kWh'}}</div>
                                <div fxFlex="5"></div>
                                <div fxFlex="16" fxLayoutAlign="center"
                                     class="txt-p-16-4">{{totals[MonthlyEnergy.ABSORBED][TimeSlot.F2]|niceValue:'kWh'}}</div>
                                <div fxFlex="5"></div>
                                <div fxFlex="16" fxLayoutAlign="center"
                                     class="txt-p-16-4">{{totals[MonthlyEnergy.ABSORBED][TimeSlot.F3]|niceValue:'kWh'}}</div>
                                <div fxFlex="7"></div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center">
                                <div fxLayout="row" fxLayoutGap="20px" fxFlex="30" fxLayoutAlign="center center"
                                     class="txt-h-16-7">
                                    <div fxFlex="5" fxLayoutAlign="center">
                                        <app-icon name="fal-solar-panel"></app-icon>
                                    </div>
                                    <div>{{'Injection'|i18n}}</div>
                                </div>
                                <div fxFlex="5"></div>
                                <div fxFlex="16" fxLayoutAlign="center"
                                     class="txt-p-16-4">{{totals[MonthlyEnergy.INJECTED][TimeSlot.F1]|niceValue:'kWh'}}</div>
                                <div fxFlex="5"></div>
                                <div fxFlex="16" fxLayoutAlign="center"
                                     class="txt-p-16-4">{{totals[MonthlyEnergy.INJECTED][TimeSlot.F2]|niceValue:'kWh'}}</div>
                                <div fxFlex="5"></div>
                                <div fxFlex="16" fxLayoutAlign="center"
                                     class="txt-p-16-4">{{totals[MonthlyEnergy.INJECTED][TimeSlot.F3]|niceValue:'kWh'}}</div>
                                <div fxFlex="7"></div>
                            </div>
                        </div>
                        <div class="vert-line"></div>
                        <div fxFlex="2"></div>
                        <div fxLayout="column" fxLayoutGap="20px" fxFlex="15" fxLayoutAlign="center center">
                            <div class="txt-h-16-7">{{'Total'|i18n}}</div>
                            <div class="txt-p-16-7">{{totals[MonthlyEnergy.ABSORBED][TimeSlot.ALL]|niceValue:'kWh'}}</div>
                            <div class="txt-p-16-7">{{totals[MonthlyEnergy.INJECTED][TimeSlot.ALL]|niceValue:'kWh'}}</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>

    </form>
</div>
